// extracted by mini-css-extract-plugin
export default {"sellingPoint":"selling-points-module__sellingPoint__B5jYz","tick":"selling-points-module__tick__ybPYv"};